import { useEffect, useState } from 'react';
import { SocketNamespace } from '@trinity/chat';
import type { Socket } from 'socket.io-client';
import { useGetSocket } from './useGetSocket';
import { useSetupDefaultSocketListeners } from './useSetupDefaultListeners';

export const useChatSocket = (chatIdentifier: string): Socket => {
  const [socket, setSocket] = useState<Socket>();
  const getSocket = useGetSocket(SocketNamespace.Chat);

  useEffect(() => {
    if (chatIdentifier) {
      const newSocket = getSocket();

      setSocket(newSocket);

      newSocket.emit('subscribe', chatIdentifier);

      return () => {
        newSocket.emit('unsubscribe', chatIdentifier);
        newSocket.disconnect();
      };
    }
  }, [chatIdentifier, getSocket]);

  useSetupDefaultSocketListeners(socket, SocketNamespace.Chat);

  return socket;
};